import { render } from "./CashbackRule.vue?vue&type=template&id=59784628&scoped=true"
import script from "./CashbackRule.vue?vue&type=script&lang=js"
export * from "./CashbackRule.vue?vue&type=script&lang=js"

import "./CashbackRule.vue?vue&type=style&index=0&id=59784628&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59784628"]])

export default __exports__